export const teams = {
	GRANCANARIA: [
		{
			name: "Turpiales",
			createdAt: "2025",
			IG: "turpiales_gc",
		},
		{
			name: "Dinamitas",
			createdAt: "2022",
			IG: "dinamita_kkclub",
		},
	],
	TENERIFE: [
		{
			name: "Panteras", // de granadilla
			createdAt: "2011",
			IG: "clubpanteraskkb",
			// inactive: true,
		},
		{
			name: "Relámpago",
			createdAt: "2013",
			IG: "cdrelampago_kickingball",
			inactive: true,
		},
		{
			name: "Sox",
			createdAt: "2014",
			IG: "soxkickingball",
			inactive: true,
		},
		{
			name: "DreamTeam",
			createdAt: "2015",
			IG: "dreamteamtenerife",
			inactive: true,
		},
		{
			name: "Deportivo",
			createdAt: "2021",
			IG: "deportivotenerifekickingball",
			inactive: true,
		},
		{
			name: "Trébol",
			createdAt: "2023",
			IG: "kickingballtrebol2023",
		},
		// { no se si es gran canaria
		// 	name: "Kickingball Sur",
		// 	// createdAt: "",
		// 	// IG: "",
		// 	inactive: true,
		// },
	],
	MADRID: [
		{
			name: "Espartanas",
			createdAt: "2015",
			IG: "espartanaskickingball",
		},
		{
			name: "Guerreras",
			createdAt: "2015",
			inactive: true,
		},
		{
			name: "Panteras",
			createdAt: "2017",
			IG: "kickingball_panterasdemadrid",
		},
		{
			name: "Murallas",
			createdAt: "2017",
			IG: "murallasdemadridkickingball",
		},
		{
			name: "Tropicales",
			createdAt: "2019",
			IG: "tropicaleskickingballmadrid",
		},
		{
			name: "Vikingas",
			createdAt: "2020",
			IG: "vikingaskickingballmadrid",
		},
		{
			name: "Las Panas",
			createdAt: "2020",
			IG: "laspanasdevenezuelakickingball",
		},
		{
			name: "Semillitas",
			createdAt: "2020 - Infantil",
			IG: "semillitasdemadrid_kickingball",
		},
		{
			name: "Águilas",
			createdAt: "2020",
			IG: "aguilaskickingballmadrid",
		},
		{
			name: "Ateneas",
			createdAt: "2021",
			IG: "ateneasdemadridkickingball",
			inactive: true,
		},
		{
			name: "Gladiadoras",
			createdAt: "2023",
			IG: "gladiadoraskickingballmadrid",
		},
		{
			name: "Goodies",
			createdAt: "2023",
			IG: "goodies_kickingball",
		},
		{
			name: "Fénix de Guadalajara",
			createdAt: "2024",
			IG: "lasfenix1304",
			inactive: true,
		},
		{
			name: "Huracanes de Alcalá",
			createdAt: "2024",
			IG: "huracanesdealcalakickingball",
		},
	],
	BARCELONA: [
		{
			name: "Amazonas",
			createdAt: "2016",
			IG: "amazonaskickingballbarcelona",
		},
		{
			name: "Valkirias",
			createdAt: "2020",
			IG: "valkiriaskickingballbarcelona",
			inactive: true,
		},
		{
			name: "Las Panas Bcn",
			createdAt: "2022",
			IG: "laspanasbcn_kickingball",
		},
		{
			name: "Guerreras",
			createdAt: "2024",
			IG: "guerreras_bcn_kickingball",
		},
		{
			name: "Wolves de Tarragona",
			createdAt: "2025",
			IG: "softboltarragona",
			inactive: true,
		},
	],
	ZARAGOZA: [
		{
			name: "Linces",
			createdAt: "2024",
			IG: "lincesdezaragoza",
		},
		{
			name: "Fénix",
			createdAt: "2025",
			IG: "fenixdezaragoza",
		},
	],
	BILBAO: [
		{
			name: "Guerreras",
			createdAt: "2018",
			IG: "guerreraskickingball",
			inactive: true,
		},
		{
			name: "Ateneas",
			createdAt: "2019",
			IG: "ateneas_kickingball",
			inactive: true,
		},
	],
	VALENCIA: [
		{
			name: "Turpiales",
			createdAt: "2020",
			IG: "turpialesturiakickingball",
			inactive: true,
		},
		{
			name: "Atléticas",
			createdAt: "2025",
			IG: "atleticasdevalencia",
		},
	],
	// MALAGA: [
	//     {
	//         name: 'Las Makinas',
	//         createdAt: '2021',
	//         link: '',
	//     },
	// ],
};

export const allTeams = [
	{
		key: 1,
		name: "Panteras",
		city: "Tenerife",
		email: "",
		createdAt: "2011",
		instagramLink: "/clubpanteraskkb",
		contact: "",
	},
	{
		key: 2,
		name: "Relámpago",
		city: "Tenerife",
		email: "clubrelampago.info@gmail.com",
		createdAt: "2013",
		instagramLink: "/cdrelampago_kickingball",
		contact: "Gloria - 618695105",
	},
	{
		key: 3,
		name: "Sox",
		city: "Tenerife",
		email: "",
		createdAt: "2014",
		instagramLink: "/soxkickingball",
		contact: "",
	},
	{
		key: 4,
		name: "Dream Team",
		city: "Tenerife - Tijoco",
		email: "",
		createdAt: "2015",
		instagramLink: "/dreamteamtenerife",
		contact: "Yonni Castillo - 634234931",
	},
	{
		key: 5,
		name: "Espartanas",
		city: "Madrid",
		email: "",
		createdAt: "Julio 2015",
		instagramLink: "/espartanaskickingball",
		contact: "",
	},
	{
		key: 6,
		name: "Panteras",
		city: "Madrid",
		email: "clubdeportivokickingballmadrid@gmail.com",
		createdAt: "Abril 2017",
		instagramLink: "/kickingball_panterasdemadrid",
		contact: "Adriana Ferrer - 612561878",
	},
	{
		key: 7,
		name: "Murallas",
		city: "Madrid",
		email: "teammurallas@gmail.com",
		createdAt: "Julio 2017",
		instagramLink: "/teammurallas",
		contact: "Juan Carlos - 677283306",
	},
	{
		key: 8,
		name: "Tropicales",
		city: "Madrid",
		email: "tropicaleskickingmadrid@gmail.com",
		createdAt: "Febrero 2019",
		instagramLink: "/tropicaleskickingmadrid",
		contact: "Analys - 671297858",
	},
	{
		key: 9,
		name: "Vikingas",
		city: "Madrid",
		email: "vikingaskickingball@gmail.com",
		createdAt: "Diciembre 2020",
		instagramLink: "/vikingaskickingballmadrid",
		contact: "",
	},
	{
		key: 10,
		name: "Las Panas",
		city: "Madrid",
		email: "",
		createdAt: "Enero 2020",
		instagramLink: "/laspanasdevenezuelakickingball",
		contact: "",
	},
	{
		key: 11,
		name: "Semillitas",
		city: "Madrid",
		email: "",
		createdAt: "Julio 2020",
		instagramLink: "/laspanasdevenezuelakickingball",
		contact: "",
	},
	{
		key: 12,
		name: "Águilas",
		city: "Madrid",
		email: "",
		createdAt: "Noviembre 2020",
		instagramLink: "/aguilaskickingballmadrid",
		contact: "",
	},
	{
		key: 13,
		name: "Amazonas",
		city: "Barcelona",
		email: "kickingballbarcelona@gmail.com",
		createdAt: "Noviembre 2016",
		instagramLink: "/kickingball_amazonas",
		contact: "Andrea - 677185533",
	},
	{
		key: 14,
		name: "Valkirias",
		city: "Barcelona",
		email: "",
		createdAt: "Septiembre 2020",
		instagramLink: "/valkirias_kickingball",
		contact: "",
	},
	{
		key: 15,
		name: "Guerreras",
		city: "Bilbao",
		email: "kickingballbilbao@gmail.com",
		createdAt: "Agosto 2018",
		instagramLink: "/guerreraskickingball",
		contact: "611448740",
	},
	{
		key: 16,
		name: "Ateneas",
		city: "Bilbao",
		email: "ateneasdeeuskalherria@gmail.com",
		createdAt: "Enero 2019",
		instagramLink: "/ateneas_kickingball",
		contact: "Lucia - 673186984",
	},
	{
		key: 17,
		name: "Turpiales",
		city: "Valencia",
		email: "",
		createdAt: "Septiembre 2020",
		instagramLink: "/turpialesturiakickingball",
		contact: "",
	},
	{
		key: 18,
		name: "Las Makinas",
		city: "Málaga",
		email: "",
		createdAt: "2021",
		instagramLink: "",
		contact: "",
	},
	{
		key: 19,
		name: "Alberto Requena",
		city: "Madrid",
		email: "trainer.requena@gmail.com",
		createdAt: "",
		instagramLink: "/trainer.requena",
		contact: "",
	},
];
